import React from 'react';
import { compose } from 'recompose';
import Auth from '@aws-amplify/auth';
import { SignUp as AmplifySignUp } from 'aws-amplify-react/lib/Auth';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { Formik } from 'formik';

import { AuthState, ICognitoError } from 'types/aws-amplify';
import { withNotify, withClient, IWithNotify, IWithClient } from 'providers';
import { Layouts } from 'components';
import { onboardingProfile } from 'paths';

import { Main, ClientSidebarHeader, SignUpForm } from '../components';
import { SignUpSchema, ISignUpValues } from '../validations';
import { CLIENT_ATTRIBUTE } from '../constants';

interface IPropsEnhanced extends IWithClient, IWithNotify, RouteComponentProps {}

interface IState {
  working: boolean;
}

const enhancers = compose<IPropsEnhanced, {}>(withRouter, withClient, withNotify);

class SignUp extends AmplifySignUp<IPropsEnhanced, IState> {
  state: IState = {
    working: false,
  };

  error = (error: ICognitoError) => {
    const { notify } = this.props;

    let message = this.errorMessage(error);
    if (message) {
      message = message.split('PreSignUp failed with error ').join('');
    }
    this.setState({ working: false });
    notify.error({ message });
  };

  getAttributes() {
    const { client } = this.props;

    return {
      email: this.inputs.username,
      [CLIENT_ATTRIBUTE]: client.id,
    };
  }

  onSubmit = (values: ISignUpValues) => {
    const sanitizedValues = { ...values, username: values.username.toLowerCase() };

    Object.assign(this.inputs, sanitizedValues);

    this.setState({ working: true }, this.signUp);
  };

  signUp() {
    const { history } = this.props;
    const { username, password } = this.inputs;
    const attributes = this.getAttributes();

    const options = {
      username: username.toLowerCase(),
      password,
      attributes,
    };

    Auth.signUp(options)
      .then(({ userConfirmed, userSub }) => {
        analytics.alias(userSub);

        if (!userConfirmed) {
          return this.changeState(AuthState.confirmSignUp);
        }

        Auth.signIn(options.username, options.password).then(() => {
          this.changeState(AuthState.signedIn);
          history.push(onboardingProfile);
        });
      })
      .catch(this.error);
  }

  renderSidebar() {
    const { authData, updateUsername, updatePassword } = this.props;
    const { working } = this.state;

    const initialValues: ISignUpValues = {
      username: authData.username,
      password: '',
      acceptTerms: false,
    };

    return (
      <Formik
        onSubmit={this.onSubmit}
        initialValues={initialValues}
        validationSchema={SignUpSchema()}>
        {() => (
          <SignUpForm
            updateUsername={updateUsername}
            updatePassword={updatePassword}
            sidebar={<ClientSidebarHeader i18nKey="auth:signUpInternal" />}
            working={working}
          />
        )}
      </Formik>
    );
  }

  showComponent() {
    return (
      <Layouts.Full2Column
        sidebar={this.renderSidebar()}
        main={<Main headerI18nKey="auth:bodyHeader1" subHeaderI18nKey="auth:signUpSubHeader" />}
      />
    );
  }
}

// @ts-ignore - TODO: AWS Components are untyped
export default enhancers(SignUp);
